import { render, staticRenderFns } from "./smsConfiguration.vue?vue&type=template&id=3c63d301&scoped=true"
import script from "./smsConfiguration.vue?vue&type=script&lang=js"
export * from "./smsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./smsConfiguration.vue?vue&type=style&index=0&id=3c63d301&prod&lang=scss&scoped=true"
import style1 from "./smsConfiguration.vue?vue&type=style&index=1&id=3c63d301&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63d301",
  null
  
)

export default component.exports